import css from 'styled-jsx/css';

const styles = css`.beacon-container {
    --black: #000000;
    --dark-gray: #b3b3b3;
    --error: red;
    --green: green;
    --gray-1: #787778;
    --gray-1-5: #767676;
    --gray-2: #bbbbbb;
    --gray-2-5: #d8d8d8;
    --gray-3: #eeeeee;
    --gray-4: #f8f8f8;
    --gray-5: #fafafa;
    --gray-6: #ebebeb;
    --gray-footer: #4f4f4f;
    --gray-footer-text: #757575;
    --gray-black: #111111;
    --heading-gray: #505050;

    --mmr-yellow: #f8e71c;
    --mmr-red: #b41f00;
    --module-gray: #f7f7f7;
    --module-white: #ffffff;
    --primary-bg: #eeeeee;

    --risk-high: #e37a00;
    --risk-low: #7c993f;
    --risk-med: #ffcc00;
    --text-fg: #3b3b3b;
    --text-header: #4c5a6a;
    --tooltip-header: #4c5a69;
    --warm-grey: #898989;
    --white: #ffffff;
    --border-line: #b8b8b8;
    --orange-button: #e17a17;

    --text-dark: #3b3b3b;
    --text-med: #4f4f4f;
    --text-light: #898989;
    --text-xlight: #c4c4c4;
    --text-disabled: #b1b1b1;

    --subtle-blue-gray: #f7f9fa;
    --beacon-dark-blue: #004b71;
    --beacon-light-blue: #00c3e0;
    --beacon-bright-blue: #05c3de;
    --beacon-shadow-blue: #ace3ea;
    --primary-blue: #2998cc;
    --ice-blue: #24c0d8;
    --bright-blue: #086ea1;
    --row-blue: #06c3df;
    --dark-blue: #054c70;
    --dark-blue-2: #043954;
    --navy-blue: #0a4c71;

    --navy-gradient: linear-gradient(115deg, #054c70, #086ea1);

    /* New design variables introduced 11-12-2019 */
    --background-grey: #e5e5e5;
    --grey-200: #f0f3f5;
    --grey-300: #b4babf;
    --grey-400: #959fa6;
    --grey-500: #879199;
    --grey-600: #6b7880;
    --grey-700: #56646b;
    --grey-800: #475359;

    --error-red: #dd3636;
    --success-green: #008a00;
    --interactive-blue: #006894;

    /* New design variables introduced 7-16-2020 */
    --border-white: #D3D7DA;
    --label-grey: #3B4B59;

    @lost gutter 24px;
    --page-max-width: 1230px;
    --page-padding: 32px;
    --module-gutter: 24px;
    --half-gutter: calc(var(--module-gutter) / 2);
    --quarter-gutter: calc(var(--half-gutter) / 2);
    --module-padding: 24px;
    --mobile-padding: 4px;

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */
    --element-spacing-1: 8px;
    --element-spacing-2: calc(var(--element-spacing-1) * 2);
    --element-spacing-3: calc(var(--element-spacing-1) * 3);
    --element-spacing-4: calc(var(--element-spacing-1) * 4);

    --border-thin-width: 1px;
    --border-width: 2px;
    --border-radius: 5px;

    --xxxxsmall-font: 5px;
    --xxxsmall-font: 10px;
    --xxsmall-font: 12px;
    --xsmall-font: 14px;
    --small-font: 16px;
    --med-font: 18px;
    --large-font: 20px;
    --xlarge-font: 24px;
    --xxlarge-font: 36px;
    --xxxlarge-font: 48px;
    --title-font: 18px;
    --label-sup-font: 100%;
    --title-large-font:80px;
    --xxxxlarge-font: 100px;
    --xxxxxlarge-font: 150px;

    --h1-font: 36px;
    --h2-font: 20px;
    --p1: 16px;
    --p2: 14px;
    --caption-size: 12px;

    --h1-font-mobile: 24px;
    --h2-font-mobile: 18px;
    --p1-mobile: 16px;
    --p2-mobile: 14px;
    --caption-size-mobile: 12px;

    --sans-serif-font: 'Nimbus Sans', sans-serif;
    --condensed-font: 'Nimbus Sans Condensed', 'Nimbus Sans Light', sans-serif;
    --condensed-bold: 'Nimbus Sans Condensed Bold', 'Nimbus Sans Condensed',
        sans-serif;
    --serif-font: 'IBM Plex Serif', serif;
    --mono-font: 'Nimbus Sans', sans-serif;
    --nimbus-reg: 'Nimbus Sans Reg', sans-serif;
    --nimbus-italic: 'Nimbus Sans Italic', sans-serif;
    --nimbus-bold: 'Nimbus Sans Bold', sans-serif;
    --nimbus-light: 'Nimbus Sans Light', sans-serif;
    --nimbus-black: 'Nimbus Sans Black', sans-serif;

    --regular-weight: 400;
    --bold-weight: 700;
    --light-weight: 100;
    --normal-weight: normal;

    /* New II Design Pattern - Introduced 11-12-2019 */
    --nimbus-normal: 'Nimbus Sans', normal;

    --line-height-xs: 18px;
    --line-height-sm: 22px;
    --line-height-md: 24px;
    --line-height-lg: 26px;

}

.horizontal .options {
  display: flex;
}

.horizontal .option {
  flex: 1;
  text-align: center;
}

.wrapper {
  position: relative;
  padding-bottom: var(--element-spacing-1);
  margin-bottom: var(--element-spacing-3);
}

.error-msg {
  position: absolute;
  bottom: 0px;
  color: var(--error-red);
  font-size: var(--xsmall-font);
}

fieldset {
  margin-bottom: var(--element-spacing-2);
  border: var(--border-thin-width) solid var(--gray-3);
  position: relative;
  padding-top: var(--element-spacing-3);
  padding-bottom: var(--element-spacing-2);
}

fieldset.error {
  border-color: var(--error-red);
}

fieldset legend {
  color: var(--grey-800);
}

fieldset label {
  display: block;
  color: var(--grey-800);
  font-size: var(--p1);
  margin-bottom: var(--element-spacing-1);
}

fieldset.vertical label {
  display: inline-block;
}

fieldset.vertical {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
}

fieldset.vertical input {
  width: auto;
}
`;

export default styles;